import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Receipt, Download, Printer } from "lucide-react";
import { useLogoUrl } from "@/components/LogoUploader";
import { money, fmtDate } from "@/lib/api";

const printImage = (url, caption) => {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`<html><head><title>${caption}</title><style>body{margin:0;font-family:sans-serif;text-align:center}img{max-width:100%;max-height:90vh}p{font-size:14px;color:#334155}</style></head><body><img src="${url}" onload="window.print()"/><p>${caption}</p></body></html>`);
  w.document.close();
};

export const ReceiptThumb = ({ expense }) => {
  const [open, setOpen] = useState(false);
  const url = useLogoUrl(!!expense.receipt_path, expense.receipt_path, `/expenses/${expense.id}/receipt`);
  if (!expense.receipt_path) return <span className="text-xs text-muted-foreground" data-testid={`expense-no-receipt-${expense.id}`}>—</span>;
  return (
    <>
      <button type="button" data-testid={`expense-receipt-thumb-${expense.id}`} onClick={() => setOpen(true)} title="View receipt"
        className="h-12 w-12 rounded-lg border border-border overflow-hidden bg-secondary grid place-items-center hover:ring-2 hover:ring-emerald-500 transition-shadow">
        {url ? <img src={url} alt="Receipt" className="h-full w-full object-cover" /> : <Receipt className="h-4 w-4 text-muted-foreground" />}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid={`expense-receipt-dialog-${expense.id}`}>
          <DialogHeader>
            <DialogTitle className="font-heading">{expense.description}</DialogTitle>
            <DialogDescription>{fmtDate(expense.date)} · {money(expense.amount)}</DialogDescription>
          </DialogHeader>
          {url && <img src={url} alt="Receipt" className="max-h-[65vh] w-full object-contain rounded-lg bg-secondary" />}
          <div className="flex gap-2 justify-end">
            <a href={url || "#"} download={`receipt-${expense.date}-${expense.amount}.jpg`} data-testid={`expense-receipt-download-${expense.id}`}
              className="h-9 px-3 rounded-lg border border-border text-sm font-semibold inline-flex items-center gap-1.5 hover:bg-secondary"><Download className="h-4 w-4" /> Download</a>
            <button type="button" data-testid={`expense-receipt-print-${expense.id}`} onClick={() => printImage(url, `${expense.date} · ${expense.description} · ${money(expense.amount)}`)}
              className="h-9 px-3 rounded-lg bg-emerald-600 text-white text-sm font-semibold inline-flex items-center gap-1.5 hover:bg-emerald-700"><Printer className="h-4 w-4" /> Print</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
